<template>
  <v-card class="py-3" :elevation="is_dialog ? 0 : 5">
    <title-card text="Componentes"/>
    <v-skeleton-loader
      :loading="!show_charts"
      class="mx-auto"
      type="date-picker-days@2"
      height="535"
    >
      <v-row>
        <v-col
          v-for="(ind, idx) in curr_inds"
          :cols="curr_inds.length > 1 ? 6 : 12"
          class="py-0"
        >
          <v-row class="mx-0">
            <v-col cols="12" class="pb-0" align="center">
              <span 
                :class="{'subtitle-2': $vuetify.breakpoint.lgAndUp}"
                :style="{'color': ind.color}"
              >
                {{ind.nombre}}
              </span>
            </v-col>
            <v-col
              cols="12"
              align="center"
              justify="center"
              class="pt-0"
            >
              <v-badge
                color="white"
                bottom
                overlap
                offset-y="12"
                offset-x="28"
              >
                <template v-slot:badge>
                  <span 
                    :style="{'color': ind.color}"
                    class="title"
                    style="line-height: 1rem"
                  >
                    <!--{{format_perc(indValue(ind))}}-->
                    {{format_perc(ind.current_value)}}
                  </span>
                </template>
                <BubbleChart 
                  :ies="ies_data"
                  :col="ind"
                  :indicador="ind"
                  :value="ind.current_value"
                  :axis="axis"
                  :mean="'X'"
                  ref="bubble"
                />
              </v-badge>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-skeleton-loader>
  </v-card>
</template>


<script>

import { mapState } from "vuex";
import homeMixin from "../homeMixin";
import TitleCard from "../common/TitleCard";
import BubbleChart from "../charts/BubbleChart";
import * as d3 from 'd3';

export default {
  name: 'AxisIndicators',
  components: {
    BubbleChart,
    TitleCard,
  },
  mixins: [homeMixin],
  props:{
    ies:{
      required: false,
    },
    axis:{
      required: true,
      type: Object,
    },
    is_dialog:{
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data(){
    return {
      //        : '#CDDC39' 
      //#4a820c
        //#3e6c0a'
    }
  },
  computed:{
    ...mapState({
      ejes: state => state.ejes,      
      axes_means: state => state.axes_means,
      indicators_means: state => state.indicators_means,
      indicadores: state => state.indicadores,
      last_values: state => state.last_values,
    }),
    curr_inds(){
      if (!this.indicadores) return []
      var ref_values = this.dialog_in_ies ? this.ies : this.last_values
      var filter_values = ref_values.indicador_values.filter(val=>
        val.eje == this.axis.id && 
          (this.ies && !this.dialog_in_ies ? val.ies == this.ies.id : true))
      var inds = this.indicadores.reduce((tot, ind)=>{
          if (this.axis.id == ind.eje){
            var ind_values = filter_values.filter(val=> val.indicador == ind.id)
            var ind_mean = d3.mean(ind_values, d=> d.valor)
            tot.push({...ind, ...{current_value: ind_mean}})
          }
          return tot
        },[])
      return inds
      //return this.indicadores.filter(ind=>this.axis.id == ind.eje) || []
    },
    ies_data(){
      return this.ies || {id: 'card', nombre:'Promedio de todas las IES', 
        siglas: `${this.ies ? this.ies.siglas : 'TODAS LAS IES'}`}
    },
    dialog_in_ies(){
      return this.$router.currentRoute.name == 'ies'
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>